import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "../../../../redux/store";
import PICDashboard from "./_elements/PICDashboard";
import { authSelectors } from "redux/app/auth";

type OwnProps = {
	vesselId: string;
};

type VDMDashboardPICProps = PropsFromRedux & OwnProps;
function VDMDashboardPIC(props: VDMDashboardPICProps) {
	const { isAdmin, vesselId, tenantId } = props;
	if (!tenantId) return null;

	return (
		<div className="flex items-center mt-4 gap-x-4">
			<PICDashboard
				vesselId={vesselId}
				isAdmin={isAdmin}
				tenantId={tenantId ?? ""}
			/>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const authStore = store.app.auth;
	const loggedInUser = authSelectors(authStore).getLoggedInUser();
	const isAdmin = loggedInUser?.roleCategory === "admin";
	const tenantId = loggedInUser?.tenantId;
	return {
		isAdmin,
		tenantId,
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(VDMDashboardPIC);
